import { Component, OnInit } from '@angular/core';
import { TrainingEducationService } from '../+state';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cigna-ondemand-training',
  templateUrl: './ondemand-training.component.html',
  styleUrls: ['./ondemand-training.component.scss'],
})
export class OndemandTrainingComponent implements OnInit {
  profileData$ = this._appstateFacade.isProfileUser$;
  isImpersonatorFlag: boolean;
  operatorId: unknown;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private _service: TrainingEducationService,
    private analytics: ShellTrackHandlers,
    private _gw: AppStateGateway,
    private _appstateFacade: AppstateFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
  ) {}

  ngOnInit(): void {
    this.profileData$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((res) => {
      if (res) {
        this.operatorId = res.accessTokenBody['agent.operatorId'];
        if (this.operatorId && this.operatorId !== '') {
          this.isImpersonatorFlag = true;
        }
      }
    });
  }

  getOnDemandExploreContent(): void {
    this._service.getOnDemandExploreContent();
    this.analytics.trackEventOther({}, 'Explore Content', 'ac25030', {
      eVar119: 'MTD-1664',
      eVar120: 'explore-content-button',
      prop67: 'action',
      channel: 'Learning Center',
      pageName: 'Producer Learning Center',
      prop20: 'on demand content',
      eVar160: this._gw.getOnDemandExploreContent(),
    });
  }
  getOnDemandStepByStepGuide(): void {
    window.open(
      'https://www.brainshark.com/brainshark/viewer/presentation/785625997/4/attachment/17221640',
      '_blank',
    );
    this.analytics.trackEventOther({}, 'step-by-step guide', 'acPDL001', {
      eVar119: 'MTD-2563',
      eVar120: 'step-by-step-guide-link',
      prop67: 'action',
      channel: 'Learning Center',
      prop20: 'on demand content',
      pageName: 'Producer Learning Center',
    });
  }
}
